import { connect } from 'react-redux'
import {
  removeFileUploaded,
  setFilePending,
  uploadFiles
} from '~/store/course/action'
import { resetState } from '~/store/course/slice'
import { getPendingFileList, getProcessingFile, getUploadedFileList } from '~/store/course/selector'
import UploadFiles from './UploadFiles'

const mapStateToProps = (state) => ({
  pendingFileList: getPendingFileList(state),
  processingFile: getProcessingFile(state),
  uploadedFileList: getUploadedFileList(state)
})

const mapDispatch = { removeFileUploaded, setFilePending, uploadFiles, resetState }

export default connect(mapStateToProps, mapDispatch)(UploadFiles)
